export default __webpack_public_path__ + "static/FeatureSix-28bc9b178bf57c0368e25aeeef0c0d13.webp";